export const TARIFF_BANDS_MOCK = [
  { weight: 0.0, nextWeight: 9.99, columnKey: "0.00_9.99", label: "0.00-9.99" },
  { weight: 10.0, nextWeight: 29.99, columnKey: "10.00_29.99", label: "10.00-29.99" },
  { weight: 30.0, nextWeight: 99.99, columnKey: "30.00_99.99", label: "30.00-99.99" },
  { weight: 100.0, nextWeight: 99999999.99, columnKey: "100.00_99999999.99", label: "100.00-99999999.99" },
];

const CARRIER_PRICES = {
  DPD: [100.0, 200.0, 300.0, 500.0],
  EMEX: [112.3, 224.6, 336.9, 561.5],
  SPARK: [130.0, 240.0, 360.0, 580.0],
};

export const CROSS_DOCKING_REGISTRY_MOCK = [
  { id: 101, kato: "710000000", carrierType: "EMEX", isActive: true, locality: "Астана", address: "трасса Астана-Караганда, 63 / ул. Достык дом 1, н-п-18, подъезд №6" },
  { id: 102, kato: "750000000", carrierType: "EMEX", isActive: true, locality: "Алматы", address: "Улица Ратушного, 64д/2" },
  { id: 103, kato: "471010000", carrierType: "EMEX", isActive: true, locality: "Актау", address: "4-й микрорайон, 67А, 1 эт." },
  { id: 104, kato: "151010000", carrierType: "EMEX", isActive: true, locality: "Актобе", address: "ул. Есет-Батыра, 136" },
  { id: 105, kato: "231010000", carrierType: "EMEX", isActive: true, locality: "Атырау", address: "Улица Шокан Уалиханова, 10а, БЦ Diana" },
  { id: 106, kato: "631010000", carrierType: "EMEX", isActive: true, locality: "Усть-Каменогорск", address: "пр-т Нурсултана Назарбаева, 11/1" },
  { id: 201, kato: "271010000", carrierType: "DPD", isActive: true, locality: "Уральск", address: "ул. Курмангалиева, 52" },
  { id: 202, kato: "101010000", carrierType: "DPD", isActive: false, locality: "Семей", address: "" },
  { id: 203, kato: "591010000", carrierType: "DPD", isActive: true, locality: "Петропавловск", address: "ул. Жамбыла Жабаева, 83, 12 офис; 1 этаж" },
  { id: 204, kato: "551010000", carrierType: "DPD", isActive: true, locality: "Павлодар", address: "Улица Лермонтова, 94/3" },
  { id: 205, kato: "111010000", carrierType: "DPD", isActive: true, locality: "Кокшетау", address: "Улица Шокана Уалиханова, 154" },
  { id: 206, kato: "431010000", carrierType: "DPD", isActive: true, locality: "Кызылорда", address: "ул. Сулейменова, 58/16" },
  { id: 301, kato: "351010000", carrierType: "SPARK", isActive: true, locality: "Караганда", address: "134-й учетный квартал, ст. 867 / пр-т Бухар-Жырау 75Г, 2 эт., 206 оф." },
  { id: 302, kato: "790000000", carrierType: "SPARK", isActive: true, locality: "Шымкент", address: "ул. Байтурсынова, 87А, гостиница Bellagio" },
  { id: 303, kato: "331010000", carrierType: "SPARK", isActive: true, locality: "Талдыкорган", address: "микрорайон Жастар, дом 7 А" },
  { id: 304, kato: "391010000", carrierType: "SPARK", isActive: true, locality: "Костанай", address: "пр-т Аль-Фараби, д. 119" },
  { id: 305, kato: "311010000", carrierType: "SPARK", isActive: true, locality: "Тараз", address: "2-й переулок Абая, 1" },
];

const buildCellsForRow = (registryRow, rowIndex) => {
  const prices = CARRIER_PRICES[registryRow.carrierType] || CARRIER_PRICES.EMEX;

  return TARIFF_BANDS_MOCK.reduce((accumulator, band, bandIndex) => {
    accumulator[band.columnKey] = {
      id: registryRow.id * 10 + bandIndex,
      weight: band.weight,
      nextWeight: band.nextWeight,
      price: prices[bandIndex],
      updatedAt: rowIndex % 2 === 0 ? "2026-04-13T09:26:07.411925" : "2026-04-13T09:26:55.345051",
    };
    return accumulator;
  }, {});
};

export const getCrossDockingTariffGridMock = (crossDockingPointIds = []) => {
  const visibleRows = CROSS_DOCKING_REGISTRY_MOCK.filter((row) =>
    !crossDockingPointIds.length || crossDockingPointIds.includes(row.id)
  );

  return {
    bands: TARIFF_BANDS_MOCK,
    rows: visibleRows.map((row, rowIndex) => ({
      crossDockingPointId: row.id,
      kato: row.kato,
      cells: buildCellsForRow(row, rowIndex),
    })),
  };
};

export const CROSS_DOCKING_TARIFF_DETAILS_MOCK = CROSS_DOCKING_REGISTRY_MOCK.reduce((accumulator, row) => {
  const payload = {
    id: row.id,
    kato: row.kato,
    locality: row.locality,
    carrierType: row.carrierType,
    isActive: row.isActive,
    address: row.address || `г.${row.locality}`,
    contractTel: "",
    operationMode: {
      time: "ПН-ПТ 09:00-18:00",
      timeJson: "[{\"day\":1,\"weekend\":false,\"start\":\"09:00\",\"end\":\"18:00\"},{\"day\":2,\"weekend\":false,\"start\":\"09:00\",\"end\":\"18:00\"},{\"day\":3,\"weekend\":false,\"start\":\"09:00\",\"end\":\"18:00\"},{\"day\":4,\"weekend\":false,\"start\":\"09:00\",\"end\":\"18:00\"},{\"day\":5,\"weekend\":false,\"start\":\"09:00\",\"end\":\"18:00\"},{\"day\":6,\"weekend\":true,\"start\":\"09:00\",\"end\":\"14:00\"},{\"day\":7,\"weekend\":true,\"start\":null,\"end\":null}]",
      isActive: true,
      message: null,
    },
    updatedAt: "2026-04-09 14:00",
  };

  accumulator[row.id] = payload;
  accumulator[row.kato] = payload;
  return accumulator;
}, {});

export const getCrossDockingDetailMock = (id) => {
  if (CROSS_DOCKING_TARIFF_DETAILS_MOCK[id]) {
    return CROSS_DOCKING_TARIFF_DETAILS_MOCK[id];
  }

  return {
    id: Number(id) || id,
    kato: String(id),
    locality: "Неизвестный населенный пункт",
    carrierType: "EMEX",
    isActive: true,
    address: "",
    contractTel: "",
    operationMode: {
      time: "Не указано",
      timeJson: "[]",
      isActive: false,
      message: null,
    },
    updatedAt: "2026-04-09 14:00",
  };
};
